export class Timeshift {
    duration:number;

}
